"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactTable = require("@tanstack/react-table");
var _BaseColumn = require("../../../../components/data-display/table/column/support/BaseColumn");
var _DropdownList = _interopRequireDefault(require("../../../../components/controls/dropdown/DropdownList"));
var _Cell = require("../../../../components/data-display/table/cell/Cell.styled");
var _ButtonDropdownField = _interopRequireDefault(require("../../../../components/controls/buttons/ButtonDropdownField"));
var _components = require("../../../../components");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typeUtil = require("../../../../shared/type-util");
var _jsxRuntime = require("react/jsx-runtime");
var StyledButtonDropdownField = (0, _styledComponents.default)(_ButtonDropdownField.default).withConfig({
  displayName: "DropdownColumn__StyledButtonDropdownField",
  componentId: "sc-1b7b0i4-0"
})(["text-align:left;"]);
var CheckboxItem = function CheckboxItem(_) {
  return null;
};
var ListItem = function ListItem(_) {
  return null;
};
var isCheckBoxItem = function isCheckBoxItem(child) {
  return (0, _typeUtil.isType)(child, CheckboxItem);
};
var isListItem = function isListItem(child) {
  return (0, _typeUtil.isType)(child, ListItem);
};
var DropdownColumn = function DropdownColumn(_) {
  return null;
};
var columnHelper = (0, _reactTable.createColumnHelper)();
DropdownColumn.toColumnDef = function (child, intl, columnStateAccessor) {
  var _child$props = child.props,
    header = _child$props.header,
    keepOpenStateOnChange = _child$props.keepOpenStateOnChange;
  var _columnStateAccessor = _slicedToArray(columnStateAccessor, 2),
    columnState = _columnStateAccessor[0],
    setColumnState = _columnStateAccessor[1];
  var dropdownListOpenRowId = columnState.dropdownListOpenRowId;
  var _onOpenChange = function onOpenChange(open, rowId) {
    if (keepOpenStateOnChange) {
      setColumnState(function (oldState) {
        return _objectSpread({}, oldState, {
          dropdownListOpenRowId: open ? rowId : undefined
        });
      });
    }
  };
  return columnHelper.display(_objectSpread({}, (0, _BaseColumn.defaultColumnDef)(child.props), {
    id: header,
    cell: function cell(_ref) {
      var row = _ref.row;
      var _child$props2 = child.props,
        label = _child$props2.label,
        defaultLabel = _child$props2.defaultLabel;
      var displayLabel = label(row.original);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Cell.StyledCell, {
        align: child.props.align,
        narrow: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DropdownList.default, {
          onOpenChange: function onOpenChange(open) {
            return _onOpenChange(open, row.id);
          },
          defaultOpen: row.id === dropdownListOpenRowId,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Trigger, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButtonDropdownField, {
              children: displayLabel ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Text, {
                ellipsis: true,
                size: '2',
                children: displayLabel
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Text, {
                ellipsis: true,
                color: 'medium',
                size: '2',
                children: defaultLabel
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Content, {
            offset: 4,
            children: _react.default.Children.map(child.props.children, function (child) {
              var dataCy = child.props['data-cy'];
              if (isCheckBoxItem(child)) {
                var _child$props3 = child.props,
                  _onChange = _child$props3.onChange,
                  checked = _child$props3.checked,
                  children = _child$props3.children;
                var props = {
                  'data-cy': dataCy,
                  onChange: function onChange() {
                    return _onChange(row.original);
                  },
                  checked: typeof checked === 'function' ? checked(row.original) : checked
                };
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.CheckboxItem, _objectSpread({}, props, {
                  children: children
                }));
              } else if (isListItem(child)) {
                var _child$props4 = child.props,
                  _onClick = _child$props4.onClick,
                  _children = _child$props4.children;
                var _props = {
                  'data-cy': dataCy,
                  onClick: function onClick() {
                    return _onClick(row.original);
                  }
                };
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Item, _objectSpread({}, _props, {
                  children: _children
                }));
              } else {
                return null;
              }
            })
          })]
        })
      });
    }
  }));
};
DropdownColumn.CheckboxItem = CheckboxItem;
DropdownColumn.ListItem = ListItem;
var _default = exports.default = DropdownColumn;